var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#932178" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.633 5.723l-12.62 12.863h8.444v33.818l4.176 4.258 4.13-4.207V18.811h8.71L64.633 5.723zM22.37 21.355l.002 22.903 9.266-9.246L53.633 56.97h4.105v-3.418l-21.92-22.358 9.66-9.84H22.372zm26.938 0l-9.65 9.838 18.08 18.44V21.355h-8.43zm22.177.215l-.002 28.108L89.61 31.195l-9.43-9.625h-8.695zm13.395.883l8.566 8.742-21.96 22.399v3.597h3.933l21.855-22.29 9.438 9.62V22.453H84.88zm12.394 16.361l-18.02 18.377h27.459V48.43l-9.438-9.616zm-65.632.069l-9.272 9.256v8.832h27.39L31.643 38.883zM19.654 50.846L6.28 64.196 19.654 77.55v-9.328H52.98l4.03-4.028-4.49-4.472H19.655v-8.877zm89.778.357l-.004 8.746H76.55l-4.25 4.328 3.86 3.942h33.038v9.373l13.057-13.315-12.824-13.074zM22.377 70.977l.002 9.287 9.264 9.256 18.572-18.543H22.377zm31.713 0L31.639 93.383l-9.262-9.248v22.677h22.21l-9.544-9.527 22.695-22.65v-3.658H54.09zm17.256 0v4.175L92.56 96.316l.964.973-8.61 8.596h21.562v-21.61l-8.24 8.414-.962.967-22.242-22.68h-3.687zm7.517 0l18.412 18.767 9.202-9.379v-9.388H78.863zm-14.576.998l-3.822 3.814v33.787h-9.233l13.055 13.028 13.057-13.028h-8.717V76.31l-4.34-4.334zm-6.547 6.533l-18.816 18.78 9.547 9.526h9.27V78.508zm13.606.512v27.8h8.756l9.55-9.533L71.346 79.02z"
  }));
};